import { render, staticRenderFns } from "./PapercleanConfigurazioneMarcheListPage.vue?vue&type=template&id=2f49ae56&scoped=true"
import script from "./PapercleanConfigurazioneMarcheListPage.vue?vue&type=script&lang=js"
export * from "./PapercleanConfigurazioneMarcheListPage.vue?vue&type=script&lang=js"
import style0 from "./PapercleanConfigurazioneMarcheListPage.vue?vue&type=style&index=0&id=2f49ae56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f49ae56",
  null
  
)

export default component.exports